var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPfpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 670 670",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335,0C149.98,0,0,149.98,0,335s149.98,335,335,335,335-149.98,335-335S520.02,0,335,0ZM334.5,647c-172.04,0-311.5-139.46-311.5-311.5S162.46,24,334.5,24s311.5,139.46,311.5,311.5-139.46,311.5-311.5,311.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610,479c13.44,64.82-129.62,178.29-275.5,179-139.35.68-280-101.55-269.5-166,10.87-66.76,183.41-89.79,269.5-91.92,88.77-2.2,261.92,13.46,275.5,78.92Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 335,
    cy: 293,
    r: 157
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfpIcon);
export default __webpack_public_path__ + "static/media/pfp-icon.588675c27aaa69620989390cac01f51a.svg";
export { ForwardRef as ReactComponent };